import styled from "styled-components";

export const StyledCTASection = styled("div")`
  background: linear-gradient(135deg, #0a0f1a 0%, #1a1f2e 50%, #2a2f3e 100%);
  border-radius: 48px;
  padding: 80px 40px;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 60px 24px;
    border-radius: 32px;
    margin: 0 16px;
  }
`;

export const GradientBlob1 = styled("div")`
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, rgba(168, 85, 247, 0.2) 40%, transparent 70%);
  filter: blur(80px);
`;

export const GradientBlob2 = styled("div")`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, transparent 60%);
  filter: blur(70px);
`;

export const ContentContainer = styled("div")`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const CTATitle = styled("h1")(
  ({ theme }) => `
  color: ${theme.colorBgContainer};
  text-align: center;
  font-weight: 700;
  font-size: 40px;
  margin: 0;
`,
);

export const CTASubtitle = styled("p")`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  max-width: 600px;
  margin: 0;
`;

export const ButtonGroup = styled("div")`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
`;
